// Closed server vocabularies: literal keys also keep locale integrity checks useful.
export const STATE_KEYS = Object.freeze({
  missing: "damage_control.capture.states.missing",
  pending: "damage_control.capture.states.pending",
  rejected: "damage_control.capture.states.rejected",
  accepted: "damage_control.capture.states.accepted",
  accepted_failed: "damage_control.capture.states.accepted_failed",
  accepted_unchecked: "damage_control.capture.states.accepted_unchecked",
});
export const REASON_KEYS = Object.freeze({
  blurry: "damage_control.capture.reasons.blurry",
  too_dark: "damage_control.capture.reasons.too_dark",
  overexposed: "damage_control.capture.reasons.overexposed",
  wrong_zone: "damage_control.capture.reasons.wrong_zone",
  obstructed: "damage_control.capture.reasons.obstructed",
  too_far: "damage_control.capture.reasons.too_far",
  provider_unavailable: "damage_control.capture.reasons.provider_unavailable",
  trial_limit: "damage_control.capture.reasons.trial_limit",
  ai_disabled: "damage_control.capture.reasons.ai_disabled",
  inspection_closed: "damage_control.capture.reasons.inspection_closed",
});
export { acceptedShot } from "@/utils/damageControlReview";
export const reasonKeys = (shot) => [...new Set(((shot && shot.reason) || []).map(reason => REASON_KEYS[reason]).filter(Boolean))];
export const confirmedFindings = (shot) => Boolean(shot && (shot.findings || []).some(finding => finding.status === "confirmed"));

export function observedShot(zone, attempt) {
  if (!zone) return attempt;
  const candidates = [zone.latest_shot, zone.current_shot].filter(Boolean);
  if (!attempt) return zone.latest_shot || zone.current_shot || null;
  const newer = candidates.find(shot => shot.series > attempt.series ||
    (shot.series === attempt.series && shot.attempt > attempt.attempt));
  if (newer) return newer;
  if (!attempt.id) return attempt; // A device refusal is not present in the server payload.
  const matching = candidates.find(shot => shot.id === attempt.id);
  if (matching) return { ...attempt, ...matching };
  // Older API only exposes the last state when there is no current photo.
  // Never apply the old current photo's verdict to a voluntary retake.
  if (!zone.current_shot && !zone.latest_shot && zone.state && zone.state !== "missing") {
    return { ...attempt, state: zone.state };
  }
  return attempt;
}
